<template>
  <div class="fondo-principal">
    <div class="fondo-azul">
      <img class="logo" src="img/corazon-logo.png" />
      <h2 class="titulo">VALIDACIÓN de DESCUENTOS</h2>
      <Formulario ref="formulario" class="formulario">
        <input
          v-model="data.dniAfiliado"
          required
          placeholder="INGRESE DNI del CLIENTE"
          class="form-control m-top36"
        />
        <input
          v-model="data.precio"
          required
          placeholder="INGRESE el PRECIO"
          class="form-control m-top36"
        />

        <div v-if="listaDescuentos">
          <select
            v-if="listaDescuentos.length"
            v-model="data.descuento"
            placeholder="INGRESE el % DESCUENTO"
            class="form-select m-top36"
            aria-label="Default select example"
          >
            <option
              v-for="desc in listaDescuentos"
              :key="desc.id"
              :value="desc"
            >
              {{ desc.porcentaje }}% | {{ desc.diasHabilitados | diasSemana }}
            </option>
          </select>
          <div v-else class="desaprobado">
            <p>No tienes beneficios aprobados con descuentos estándares.</p>
          </div>
          <div v-if="SuperaLimite" class="desaprobado">
            <p>
              Se alcanzó el límite de descuento para este beneficio ({{
                LimiteDescuento
              }}).
            </p>
          </div>
        </div>
        <div v-else class="aprobado">
          <p>Cargando descuentos...</p>
        </div>
        <div class="contenedor-precio-final">
          <label class="precio-final">ESTE es el PRECIO FINAL</label>
          <input
            readonly
            v-model="PrecioFinal"
            class="form-control input-precio-final"
          />
        </div>
      </Formulario>

      <button
        :disabled="!listaDescuentos || !listaDescuentos.length"
        @click="continuar()"
        type="button"
        class="btn btn-success confirmar-venta__descuentos"
      >
        <div v-if="trabajando">
          <div class="icono-izquierda d-inline">
            <div class="spinner-border icono" role="status"></div>
          </div>
          VERIFICANDO...
        </div>
        <div v-else>
          <span> <img class="exito" src="img/exito.png" />CONFIRMAR VENTA</span>
        </div>
      </button>
      <p
        v-if="listaDescuentos && !listaDescuentos.length"
        class="info-bajo-input"
      >
        Debes tener un beneficio aprobado con un descuento estándar para
        continuar.
      </p>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import Formulario from "../panel/formularios/Formulario.vue";
import { ClienteService } from "../../servicios/cliente.service.js";
import { ComercianteService } from "../../servicios/comerciante.service.js";
import { PagoService } from "../../servicios/pago.service.js";
import { RouteNames } from "../../routes/comerciante.routes";
import { Util } from "../../util.js";

export default {
  components: {
    Formulario,
  },
  data() {
    return {
      clienteService: new ClienteService(),
      data: {
        dniCliente: null,
        precio: null,
        descuento: null,
      },
      listaDescuentos: null,
      service: new PagoService(),
      trabajando: false,
    };
  },
  computed: {
    PrecioFinal() {
      let precioFinal = 0;
      const monto = this.data.precio ?? 0;
      const descuento = this.data.descuento?.porcentaje ?? 0;
      const limite = this.data.descuento?.limiteDescuento ?? -1; // -1 es el valor por defecto que indica que no hay límite.

      const montoDescuento = monto * (descuento / 100);

      montoDescuento > limite && limite > -1
        ? (precioFinal = monto - limite)
        : (precioFinal = monto - montoDescuento);

      return "$ " + precioFinal.toFixed(2);
    },
    SuperaLimite() {
      const monto = this.data.precio ?? 0;
      const descuento = this.data.descuento?.porcentaje ?? 0;
      const limite = this.data.descuento?.limiteDescuento ?? -1;

      const montoDescuento = monto * (descuento / 100);

      if (montoDescuento > limite && limite > -1) {
        return true;
      } else {
        return false;
      }
    },
    LimiteDescuento() {
      return Util.formatMoney(this.data.descuento.limiteDescuento);
    },
  },
  methods: {
    continuar() {
      this.$refs.formulario.limpiarFeedback();

      if (this.$refs.formulario.esValido()) {
        this.trabajando = true;

        this.clienteService
          .getAfiliadoByDni(this.data.dniAfiliado)
          .then((response) => {
            const afiliado = response.data;

            Swal.fire({
              title: "¿Confirmar venta?",
              icon: "question",
              html:
                "Cliente: <b>" +
                afiliado.nombre +
                "</b>. <br/>" +
                "Precio: $" +
                this.data.precio +
                ". Descuento: " +
                (this.data.descuento?.porcentaje ?? 0) +
                "%<br/>" +
                "Precio final: <b>" +
                this.PrecioFinal +
                "</b>",
              showCancelButton: true,
              showLoaderOnConfirm: true,
              confirmButtonColor: "#28a745",
              cancelButtonColor: "rgb(125 133 140)",
              confirmButtonText: "Si, confirmar",
              cancelButtonText: "Cancelar",
              preConfirm: () => {
                return this.service
                  .crear(this.getDatosPago(this.data))
                  .then((response) => {
                    const dtoVenta = response.data;

                    dtoVenta.nombreCliente = afiliado.nombre;

                    this.irAVoucherVenta(dtoVenta);
                  })
                  .catch(() => {
                    Swal.showValidationMessage(
                      "Ocurrió un error al guardar la venta"
                    );
                  });
              },
            });
          })
          .catch((error) => {
            let mensaje = "Ocurrió un error inesperado";

            if (error.response.status != 500){
              mensaje = error.response.data;
            } 

            Swal.fire({
              icon: "error",
              title: "Error",
              text: mensaje,
            });
          })
          .finally(() => {
            this.trabajando = false;
          });
      } else {
        this.$refs.formulario.mostrarFeedback();
      }
    },
    getDatosPago(data) {
      return {
        dniAfiliado: data.dniAfiliado,
        idDescuento: data.descuento.id,
        precio: data.precio,
      };
    },
    irAVoucherVenta(venta) {
      this.$router.push({ name: RouteNames.VoucherVenta, params: { venta } });
    },
    limpiar() {
      this.data = {
        dniCliente: null,
        precio: null,
        descuento: this.data.descuento,
      };
    },
    aplicarLimite(val) {
      this.superaLimiteDescuento = val;
    },
  },
  mounted() {
    ComercianteService.getDescuentos().then((response) => {
      this.listaDescuentos = response.data;

      // Dejar el primer descuento seleccionado
      if (this.listaDescuentos.length) {
        this.data.descuento = this.listaDescuentos[0];
      }
    });
  },
};
</script>
<style lang="scss" scoped>
/* General */

p,
label,
input,
select,
button {
  font-family: "roboto-400";
}

h2,
button {
  font-family: "roboto-700";
}

input::-webkit-input-placeholder {
  color: var(--color-estructura-a);
}

input::-moz-placeholder {
  color: var(--color-estructura-a);
}

input:-ms-input-placeholder {
  color: var(--color-estructura-a);
}

input::-ms-input-placeholder {
  color: var(--color-estructura-a);
}

input::placeholder {
  color: var(--color-estructura-a);
}

.desaprobado,
.aprobado {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.desaprobado p,
.aprobado p {
  margin-bottom: 0px;
  position: absolute;
}

.desaprobado p,
.info-bajo-input {
  color: var(--color-alerta);
}

.aprobado p {
  color: var(--color-exito-claro);
  margin-top: 22px;
  font-size: 20px;
}

.fondo-principal {
  // background-color: var(--color-gris);
  background-color: var(--color-estructura-a);
  height: 100%;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.fondo-azul {
  height: 800px;
  padding: 55px 62px;
  // width: 630px;
  width: 100%;
  background-color: var(--color-estructura-a);
  display: flex;
  flex-direction: column;
  align-items: center;

  .logo {
    width: 230px;
  }
  .titulo {
    width: 630px;
    font-size: 24px;
    line-height: 28.13px;
    color: white;
    margin-top: 40px;
    margin-bottom: 3px;
    padding: 7px 0px;
    border-top: solid 1px white;
    border-bottom: solid 1px white;
  }
  .formulario {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: flex-end;
    -ms-flex-align: flex-end;
    align-items: flex-end;
    column-gap: 2rem;
    // & > div {
    //   width: 100%;
    // }
    .m-top36 {
      margin-top: 36px;
    }
    .form-control,
    .form-select {
      width: 15rem;
      height: 36px;
      text-align: center;
      font-size: 16px;
      color: var(--color-estructura-a);
      line-height: 18.75px;
    }
    .precio-final {
      color: white;
      margin-top: 55px;
      margin-bottom: 3px;
    }
    .input-precio-final {
      // width: 274px;
      width: 15rem;
      font-size: 24px;
      font-family: "roboto-700" !important;
    }
  }
  .confirmar-venta__descuentos {
    margin-top: 44px;
    height: 48px;
    width: 274px;
    background: var(--color-exito);
  }
}

.exito {
  width: 16px;
  margin-right: 10px;
}

@media screen and (max-width: 1070px) {
  .fondo-azul {
    .formulario {
      column-gap: 1rem;
      .form-control,
      .form-select {
        width: 22vw;
        font-size: 14px;
        padding-left: 0px;
        padding-right: 0px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .fondo-azul {
    height: 950px;
    padding: 95px 7% 55px;
    width: 100%;
    .formulario {
      flex-direction: column;
      align-content: center;
      align-items: center;
      .form-control,
      .form-select {
        width: 64vw;
      }
      .contenedor-precio-final{
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
  .precio-final {
    margin-top: 77px;
  }
}

@media screen and (max-width: 360px) {
  .fondo-azul {
    height: 733px;
    padding: 42px 14px;
    width: 100%;
    .fondo-azul .logo {
      width: 130px;
    }

    .titulo {
      margin-top: 12px;
      font-size: 6.6vw;
    }

    .formulario {
      padding: 0px 28px;
      .form-control,
      .form-select {
        font-size: 16px;
      }
    }

    .desaprobado p,
    .info-bajo-input {
      font-size: 10px;
    }

    .aprobado p {
      margin-top: 15px;
      font-size: 12px;
    }

    .precio-final {
      margin-top: 33px;
    }

    .input-precio-final {
      width: 100%;
    }

    .confirmar-venta__descuentos {
      // width: calc(100% - 56px);
      width: 64vw;
      font-size: 13px;
    }
  }
}

</style>
